import {getCurrentInstance, computed, reactive} from 'vue';
import {ModuleBankInfo} from '@/stores/moduleConst';
import {useStore} from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheBankInfoComboConfig = () => {
  const {proxy} = getCurrentInstance();

  const store = useStore();

  const bankInfoCombo = computed(() => {
    const bankInfos = store.getters[`${ModuleBankInfo}/items`];
    return bankInfos.filter(x => !x.inactive);
  });

  // config columns combo
  const cacheBankInfoComboConfig = reactive({
    data: bankInfoCombo,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'bank_account',
        width: 180,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên NH, KB',
        dataField: 'bank_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 420,
      },
    ],
    displayField: 'bank_account',
    valueField: 'bank_account',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'bank_account',
      titleSearch: 'Tìm nhanh tài khoản NH, KB',
    },
  });

  return {cacheBankInfoComboConfig, bankInfoCombo};
};
